<div class="redline-toolbar">
  <!-- Line width -->
  <div class="redline-toolbar__width" [class.redline-toolbar__width--disabled]="lineWidthDisabled">
    <mat-icon class="redline-toolbar__width-icon">line_weight</mat-icon>
    <input
      type="range"
      min="1"
      max="10"
      step="1"
      [value]="lineWidth"
      [disabled]="lineWidthDisabled"
      (input)="lineWidthChange.emit(+$any($event.target).value)"
      [title]="lineWidthDisabled ? 'Line width (not available for text)' : 'Line width'"
      class="redline-toolbar__range"
    />
    <span class="redline-toolbar__width-val">{{ lineWidth }}</span>
  </div>

  <span class="redline-toolbar__sep"></span>

  <!-- Drawing tools -->
  <div class="redline-toolbar__group">
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'arrow'"
      (click)="toolChange.emit('arrow')"
      title="Arrow"
    >
      <mat-icon>north_east</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'ellipse'"
      (click)="toolChange.emit('ellipse')"
      title="Ellipse"
    >
      <mat-icon>radio_button_unchecked</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'rectangle'"
      (click)="toolChange.emit('rectangle')"
      title="Rectangle"
    >
      <mat-icon>crop_square</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'polygon'"
      (click)="toolChange.emit('polygon')"
      title="Polygon (double-click to close)"
    >
      <mat-icon fontSet="material-icons-outlined">pentagon</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'cloud'"
      (click)="toolChange.emit('cloud')"
      title="Cloud (double-click to close)"
    >
      <mat-icon>cloud_queue</mat-icon>
    </button>
  </div>

  <span class="redline-toolbar__sep"></span>

  <div class="redline-toolbar__group">
    <button
      type="button"
      class="pdfm-btn"
      [class.pdfm-btn--active]="activeTool === 'textbox'"
      (click)="toolChange.emit('textbox')"
      title="Text Box"
    >
      <mat-icon>text_fields</mat-icon>
    </button>
  </div>

  <span class="redline-toolbar__sep"></span>

  <!-- Undo / Redo -->
  <div class="redline-toolbar__group">
    <button
      type="button"
      class="pdfm-btn"
      [disabled]="!canUndo || isUndoRedoBusy"
      (click)="undo.emit()"
      title="Undo (Ctrl+Z)"
    >
      <mat-icon>undo</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [disabled]="!canRedo || isUndoRedoBusy"
      (click)="redo.emit()"
      title="Redo (Ctrl+Y)"
    >
      <mat-icon>redo</mat-icon>
    </button>
  </div>

  <span class="redline-toolbar__sep"></span>

  <!-- Delete -->
  <div class="redline-toolbar__group">
    <button type="button" class="pdfm-btn pdfm-btn--danger" (click)="clearActive.emit()" title="Delete selected">
      <mat-icon>delete</mat-icon>
    </button>
    <button type="button" class="pdfm-btn pdfm-btn--danger" (click)="clearAll.emit()" title="Clear all annotations">
      <mat-icon>delete_forever</mat-icon>
    </button>
  </div>

  <span class="redline-toolbar__sep"></span>

  <!-- Zoom & rotate -->
  <div class="redline-toolbar__group">
    <button type="button" class="pdfm-btn" (click)="zoomOut.emit()" title="Zoom out">
      <mat-icon>zoom_out</mat-icon>
    </button>
    <button type="button" class="pdfm-btn" (click)="zoomIn.emit()" title="Zoom in">
      <mat-icon>zoom_in</mat-icon>
    </button>
    <button type="button" class="pdfm-btn" (click)="rotate.emit()" title="Rotate 90°">
      <mat-icon>rotate_right</mat-icon>
    </button>
  </div>

  <span class="redline-toolbar__sep"></span>

  <!-- Download -->
  <div class="redline-toolbar__group">
    <button
      type="button"
      class="pdfm-btn"
      [disabled]="isDownloading"
      (click)="download.emit()"
      title="Download with markups"
    >
      <mat-icon>download</mat-icon>
    </button>
    <button
      type="button"
      class="pdfm-btn"
      [disabled]="isSendingToMips"
      (click)="sendToMips.emit()"
      title="Send with markups to MIPS"
    >
      <mat-icon>cloud_upload</mat-icon>
    </button>
  </div>
</div>
